import React, { useEffect } from "react"
import types from "prop-types"
import { useDispatch } from "react-redux"
import withReduxProvider from "shared/withReduxProvider"
import {
  setCategories,
  setSubmissionColumnOptions,
  setTaskColumnOptions,
} from "reduxSlices/taskReportBuilderSlice"
import { reportExportBuilderColumnOptionShape } from "utils/propTypeShapes"
import TaskReportBuilder from "TaskReportBuilder"

const TaskReportCreator = ({ categories, submissionColumnOptions, taskColumnOptions }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setCategories(categories))
    dispatch(setSubmissionColumnOptions(submissionColumnOptions))
    dispatch(setTaskColumnOptions(taskColumnOptions))
  }, [dispatch, categories, submissionColumnOptions, taskColumnOptions])

  return (<TaskReportBuilder />)
}

TaskReportCreator.propTypes = {
  categories: types.arrayOf(types.shape({
    name: types.string.isRequired,
    slug: types.string.isRequired,
  })).isRequired,
  submissionColumnOptions: types.arrayOf(reportExportBuilderColumnOptionShape).isRequired,
  taskColumnOptions: types.arrayOf(reportExportBuilderColumnOptionShape).isRequired,
}

export default withReduxProvider(TaskReportCreator)
